import { stdCouleurBleu, stdCouleurGris } from '@commonStyle';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    height: '100%',
    width: '100%',
  },
  background: {
    flex: 1,
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },

  backgroundImageContainer: {
    width: '20%',
  },
  backgroundImage: {
    height: '100%',
  },
  mainContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: '#fff', // Overlay semi-transparent
  },
  
  logoContainer: {
    justifyContent: 'center',
    padding: 20,
    alignItems: 'center',
    flex: 1,
  },
  formContainer: {
    padding: 20,
    width: '80%',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.9)',
    gap: 20,
    flex: 1,
  },
  bottomContainer: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1,
  },
  centeredRowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  mdpContainer: {
     justifyContent: 'center',
  },
  inputLogin: {
    fontSize: 18,
    color: 'black',
    marginBottom: 30,
    borderBottomColor: 'grey',
    borderBottomWidth: 2,
  },
  passwordContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: 'grey',
    borderBottomWidth: 2,
    marginBottom: 30,
  },
  passwordInput: {
    flex: 1,
    marginBottom: 0,
    borderBottomWidth: 0,
  },
  buttonBleu: {
    backgroundColor: stdCouleurBleu,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
    alignItems: 'center',
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  linkText: {
    color: stdCouleurBleu,
  },
  backgroundPlaceholder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white', // Couleur de fond temporaire
  },
  clufLink: {
    color: stdCouleurGris,
    fontSize: 12,
    textDecorationLine: 'underline',
    marginTop: 10,
    marginBottom: 10,
  },
  switchLabelText: {
    textAlign: 'center',
  },
  sectionContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default styles